import { IBusinessInfo, IShopSchema } from "../../shared/types";

import {
  collection,
  doc,
  getDoc,
  getFirestore,
  getDocs,
  query,
  serverTimestamp,
  where,
  Timestamp,
  runTransaction,
} from "firebase/firestore";

const getCurrentBusinessMetadata = async (userId: string) => {
  try {
    const db = getFirestore();

    const docRef = doc(db, "businesses", userId);

    const document = await getDoc(docRef);
    if (document.exists()) {
      return document.data() as IBusinessInfo;
    }

    throw new Error("business not found");
  } catch (error) {
    throw error;
  }
};

const getShops = async (userId: string) => {
  const shops: IShopSchema[] = [];

  try {
    const db = getFirestore();
    const q = query(collection(db, "businesses", userId, "shops"));

    const response = await getDocs(q);

    response.forEach((resObj) => {
      if (resObj.exists()) {
        const newTimeStamp = new Timestamp(
          resObj.data().created_at.seconds,
          resObj.data().created_at.nanoseconds
        ).toMillis();

        const newShop = {
          ...resObj.data(),
          created_at: new Date(newTimeStamp),
        };

        shops.push(newShop as IShopSchema);
      }
    });

    return shops;
  } catch (error) {
    throw error;
  }
};

const createShop = async (shop_name: string, user_id: string) => {
  try {
    const new_shop_ref = doc(
      getFirestore(),
      "businesses",
      user_id,
      "shops",
      shop_name
    );
    const business_ref = doc(getFirestore(), "businesses", user_id);
    const new_shop_data = {
      cash_in_shop: 0,
      created_at: serverTimestamp(),
      gross_profit: 0,
      gross_revenue: 0,
      items_in_stock: 0,
      name: shop_name,
    };

    // await setDoc(new_shop_ref, new_shop_data)

    await runTransaction(getFirestore(), async (transaction) => {
      const business_data = (
        await transaction.get(business_ref)
      ).data() as IBusinessInfo;

      transaction
        .update(business_ref, {
          stats: {
            ...business_data.stats,
            total_shops: business_data.stats.total_shops + 1,
          },
        })
        .set(new_shop_ref, new_shop_data);
    });

    return new_shop_data as IShopSchema;
  } catch (error) {
    throw error;
  }
};

const exportShops = async (
  start_date: Date,
  end_date: Date,
  user_id: string
) => {
  try {
    const shops: IShopSchema[] = [];
    const db = getFirestore();

    const ref = collection(db, "businesses", user_id, "shops");
    const refQuery = query(
      ref,
      where("created_at", ">=", start_date),
      where("created_at", "<=", end_date)
    );

    const response = await getDocs(refQuery);

    response.forEach((resObj) => {
      if (resObj.exists()) {
        const newTimeStamp = new Timestamp(
          resObj.data().created_at.seconds,
          resObj.data().created_at.nanoseconds
        ).toMillis();

        const newShop = {
          ...resObj.data(),
          created_at: new Date(newTimeStamp),
        };

        shops.push(newShop as IShopSchema);
      }
    });

    return shops;
  } catch (error) {
    throw error;
  }
};

const Business = {
  getCurrentBusinessMetadata,
  getShops,
  createShop,
  exportShops,
};

export default Business;
